// extracted by mini-css-extract-plugin
export default {"toggleContainer":"Toggle_toggleContainer__trhfF","toggleInput":"Toggle_toggleInput__32s91","toggleSlider":"Toggle_toggleSlider__Y3tNk","disabled":"Toggle_disabled__h4geJ"};